// Dependencies
require("webstrap/type");
require("webstrap/responsive-utilities");
require("grid");

// Styles
require("./texte-1-1.scss");



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/texte-1/view-1/index.js
// module id = 235
// module chunks = 0